// @ts-check

import createStripeWalletStrategy from '../../../utils/createStripeWalletPayload';

/**
 * @typedef {import('../../../utils/createStripeWalletPayload').StripeWalletStrategy} StripeApplePayStrategy
 */

/**
 * Stripe Apple Pay strategy.
 * Thin wrapper over the shared Stripe wallet builder, parameterized with the `apple_pay_data`
 * nested key. See `createStripeWalletStrategy` for the payload contract.
 * @type {import('../../../utils/createStripeWalletPayload').StripeWalletStrategy}
 */
const stripeApplePayStrategy = createStripeWalletStrategy({ walletDataKey: 'apple_pay_data' });

export default stripeApplePayStrategy;
